import axios from 'axios'
import config from '../config'
import {getDoctorToken} from '../utils'

const getPatientDetailApi = async (params) => {
    const response = await axios({
        url: `${config.api.base_url}patient/${params.id}`,
        method: "get",
        params: params,
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getDoctorToken()}`
        }
    });

    console.log("Faizannnnnnn", response);

    return response

}

export default getPatientDetailApi